import { Data, Grid, Modal as ModalModule, UI } from 'common';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DateCellRenderer from '../shared/DateCellRenderer.component';
import HistoryCommunication from '../utils/HistoryCommunication';
import CancelPickupModal from './CancelPickupModal.component';
import ScheduleUspsPickupModal from './ScheduleUspsPickupModal.component';

const { GridPanel } = Grid;
const { Spinner, WrappedToolbar } = UI;
const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { Carrier } = Data;

export default class ManagePickupsModal extends Component {
	constructor(props) {
		super(props);
		const {
			data: { pickups },
		} = this.props;

		this.state = {
			selectedPickup: {},
			pickupList: pickups || [],
			columnDefs: [
				{
					headerName: 'Pickup Date' /*  */,
					flex: 1,
					valueGetter: ({ data: { pickupWindow } }) => {
						const { startAt } = pickupWindow;
						return new Date(startAt);
					},
					cellRenderer: 'DateCellRenderer',
					sort: 'desc',
					sortable: true,
				},
				{
					headerName: 'Carrier',
					field: 'carrier',
					flex: 1,
					cellRenderer: ({ value }) => {
						if (value === Carrier.USPS) {
							return 'USPS & GlobalPost';
						}
						return value;
					},
				},
				{
					headerName: 'Confirmation Number',
					field: 'pickupId',
					flex: 1,
				},
				{
					headerName: '# of Items',
					field: 'numberOfItemsInPickup',
					flex: 1,
					cellRenderer: ({ value }) => {
						if (value !== 0) {
							return value;
						}
					},
				},
			],
			isLoading: false,
		};
	}

	/**
	 * Callback handler for Cancel Pickup and refresh grid view
	 */
	cancelPickup = async () => {
		const { data } = this.props;
		const { showError } = this.context;
		const { selectedPickup } = this.state;
		this.setState({ isLoading: true });

		const response = await HistoryCommunication.deleteSchedulePickup(
			selectedPickup.pickupId
		);

		if (HistoryCommunication.isSuccessful(response)) {
			const { pickups } = (await data.fetchPickups()) || {};

			this.setState({
				pickupList: pickups || [],
			});
		} else {
			showError({ response });
		}

		this.setState({ isLoading: false });
	};

	/**
	 * Display the 'CancelPickupModal' modal view.
	 */
	onClickCancelPickupButton = async () => {
		const { showModal } = this.context;
		const { selectedPickup } = this.state;

		showModal({
			component: CancelPickupModal,
			data: {
				selectedPickup,
				onCancelPickupCallback: this.cancelPickup,
			},
		});
	};

	/**
	 * Update selected row in the Grid
	 * @param {rowNodes} rowNodes
	 */
	onSelectionChanged = (rowNodes = []) => {
		const { data = {} } = rowNodes[0];

		this.setState({
			selectedPickup: { ...data },
		});
	};

	/**
	 * Handler for Schedule Pickup > USPS
	 */
	onClickUSPSPickup = () => {
		const {
			data: { onRefreshGridAPI },
		} = this.props;
		const { showModal } = this.context;
		const { selectedPickup } = this.state;

		showModal({
			component: ScheduleUspsPickupModal,
			data: {
				selectedPickup,
				isEditPickup: true,
				onRefreshGridAPI,
			},
		});
	};

	render() {
		const {
			modalId,
			data: { schedulePickupOptions },
		} = this.props;
		const { selectedPickup, columnDefs, isLoading, pickupList } = this.state;
		const buttons = [
			{
				label: 'Schedule Pickup',
				menuClassName: 'schedule-pickup-split-button-menu',
				dataqa: 'schedule-pickup',
				disabled: false,
				model: schedulePickupOptions,
			},
			{
				label: 'Cancel Pickup',
				dataqa: 'cancel-pickup',
				disabled: isLoading || isEmpty(selectedPickup),
				onClick: this.onClickCancelPickupButton,
			},
		];

		return (
			<Modal
				modalId={modalId}
				className="history-pickup manage-pickups-modal"
				header="Manage Pickups"
				hideFooter
			>
				<WrappedToolbar
					className="history history-toolbar"
					buttons={buttons}
					dataqa="history-toolbar"
				/>
				<GridPanel
					className="manage-pickups-grid"
					columnDefs={columnDefs}
					defaultColDef={{
						suppressSizeToFit: true,
						suppressMovable: true,
						sortable: false,
						suppressMenu: true,
					}}
					domLayout="autoHeight"
					frameworkComponents={{ DateCellRenderer }}
					rowData={pickupList}
					showPagination={false}
					rowSelection="single"
					dataqa="manage-pickups-grid"
					onSelectionChanged={this.onSelectionChanged}
					noRowsOverlayParams={{
						noDataOverlayText: true,
					}}
				/>
				{isLoading && <Spinner msg="Updating Pickups" />}
			</Modal>
		);
	}
}

ManagePickupsModal.propTypes = {
	data: PropTypes.shape({
		refreshPickupOptionsCallback: PropTypes.func,
	}),
	schedulePickupOptions: PropTypes.array,
};

ManagePickupsModal.contextType = ModalContext;
